import React, {createContext, useContext, useEffect, useState} from 'react';
import ScheduleService from "../../API/ScheduleService";
import {getUserIdFromCookie} from "../table/CookiesMethods";

const PermissionContext = createContext({
    canEditSchedule: false,
    isPermissionsLoading: true,
    permissionsError: '',
});

export const PermissionProvider = ({children}) => {
    const [canEditSchedule, setCanEditSchedule] = useState(false);
    const [isPermissionsLoading, setPermissionsLoading] = useState(true);
    const [permissionsError, setPermissionsError] = useState('');

    useEffect(() => {
        let isMounted = true;

        const fetchPermissions = async () => {
            setPermissionsLoading(true);
            setPermissionsError('');

            try {
                const initData = window.Telegram?.WebApp?.initData;

                if (initData) {
                    const permissions = await ScheduleService.getMyPermissions(initData);

                    if (isMounted) {
                        setCanEditSchedule(Boolean(permissions?.canEditSchedule));
                    }
                    return;
                }

                const userId = localStorage.getItem("telegram-user-id") || getUserIdFromCookie();

                if (!userId) {
                    if (isMounted) {
                        setCanEditSchedule(false);
                    }
                    return;
                }

                const permission = await ScheduleService.getEditPermission(userId);

                if (isMounted) {
                    setCanEditSchedule(Boolean(permission));
                }
            } catch (error) {
                if (isMounted) {
                    setCanEditSchedule(false);
                    setPermissionsError(error?.message || 'permissions_error');
                }
            } finally {
                if (isMounted) {
                    setPermissionsLoading(false);
                }
            }
        };

        fetchPermissions();

        return () => {
            isMounted = false;
        };
    }, []);

    return (
        <PermissionContext.Provider value={{canEditSchedule, isPermissionsLoading, permissionsError}}>
            {children}
        </PermissionContext.Provider>
    );
};

export const usePermissions = () => useContext(PermissionContext);
